export const getLatestTermsOfUse = state => state.latest_terms_of_use;
// export const getLatestTermsOfUseToAccept = state => state.latest_terms_of_use_to_accept;
